// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__33qrB","overflowing":"ReadFullNote_overflowing__1xkdc"};